export const CURRENCY = "USD";
export const CURRENCY_SYMBOL = "$";
export const TRANSACTION_FEE_PCT = 0.05;
export class SelectedTicket {
    constructor(params) {
        this.ticket = params.ticket;
        this.quantity = params.quantity;
        this.discount = params.discount;
    }
    get total() {
        return this.quantity * this.ticket.currentPrice;
    }
    get totalToFixed() {
        return this.total.toFixed(2);
    }
    get payablePerTicket() {
        var _a;
        return Math.min(this.ticket.currentPrice, ((_a = this.discount) === null || _a === void 0 ? void 0 : _a.price) !== undefined &&
            this.discount.isValid([this.selectedTicketType])
            ? this.discount.price
            : this.ticket.currentPrice);
    }
    get payable() {
        return this.quantity * this.payablePerTicket;
    }
    get payableToFixed() {
        return this.payable.toFixed(2);
    }
    get totalDiscount() {
        var _a;
        return Math.max((((_a = this.discount) === null || _a === void 0 ? void 0 : _a.price) !== undefined &&
            this.discount.isValid([this.selectedTicketType])
            ? this.ticket.currentPrice - this.discount.price
            : 0) * this.quantity, 0);
    }
    get totalDiscountToFixed() {
        return this.totalDiscount.toFixed(2);
    }
    get discountTagToFixed() {
        return this.discountTag.toFixed(0);
    }
    get discountTag() {
        return this.ticket.discount || 0;
    }
    get maxQuantity() {
        if (this.discount && this.discount.remainingUses > 0) {
            return this.discount.remainingUses;
        }
        // if ([...specialTicketTypes, TicketID.GENERAL].includes(this.ticket.id)) {
        //   return 1;
        // }
        return 10;
    }
    get selectedTicketType() {
        return this.ticket.id;
    }
    get freeTicketSelected() {
        return this.ticket.currentPrice === 0;
    }
    get freeTicketWithInvalidDiscount() {
        return this.freeTicketSelected && !this.discount;
    }
    get paypalItems() {
        const ticket = this.ticket;
        return [
            {
                name: ticket.name,
                quantity: this.quantity.toString(),
                unit_amount: {
                    currency_code: CURRENCY,
                    value: ticket.currentPrice.toString(),
                },
                category: "DIGITAL_GOODS",
                description: ticket.name,
            },
        ];
    }
    get paypalAmount() {
        return {
            currency_code: CURRENCY,
            value: this.totalPlusTxnFeeToFixed,
            breakdown: {
                item_total: {
                    currency_code: CURRENCY,
                    value: this.totalToFixed,
                },
                discount: {
                    currency_code: CURRENCY,
                    value: this.totalDiscountToFixed,
                },
                handling: {
                    currency_code: CURRENCY,
                    value: this.transactionFeeToFixed,
                },
            },
        };
    }
    get transactionFee() {
        return this.payable * TRANSACTION_FEE_PCT;
    }
    get transactionFeeToFixed() {
        return this.transactionFee.toFixed(2);
    }
    get transactionFeePct() {
        return (TRANSACTION_FEE_PCT * 100).toFixed(0);
    }
    get totalPlusTxnFee() {
        return this.payable + this.transactionFee;
    }
    get totalPlusTxnFeeToFixed() {
        return this.totalPlusTxnFee.toFixed(2);
    }
}
